import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeJobMatchPreview from '../components/HomePage/sections/HomeJobMatchPreview';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface PublicJobBoardPageProps {
  onNavigate?: (view: string) => void;
}

const PublicJobBoardPage: React.FC<PublicJobBoardPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="job-board"
      title={t('pages.jobBoard.seoTitle', 'Live Tech Jobs in India | GoGrabJob')}
      description={t(
        'pages.jobBoard.seoDescription',
        'Browse live roles from Naukri, LinkedIn, and Peerlist. Sign up to see your personal match score and application packs.',
      )}
      canonical="https://www.gograbjob.com/job-board"
    >
      <div className="marketing-page-hero-band">
        <h1 className="marketing-page-hero-band__title">
          {t('pages.jobBoard.title', 'Live jobs on GoGrabJob')}
        </h1>
        <p className="marketing-page-hero-band__lede">
          {t(
            'pages.jobBoard.lede',
            'Fresh roles ingested from major boards — ranked to your profile when you sign up.',
          )}
        </p>
      </div>
      <HomeJobMatchPreview onNavigate={onNavigate} />
    </MarketingPageShell>
  );
};

export default PublicJobBoardPage;
